export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7702.d2fb0232.jpg";